import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "react-query";
import initLocalization from "./i18n";
import '@mobiscroll/react/dist/css/mobiscroll.scss';
import './index.css';
import {
    HubspotChatService
} from "crqlar-react-common/dist/services/support/HubspotChat.service";
import {Provider} from "react-redux";
import {store} from "./store/store";
import {DashboardSnackbarProvider} from "./components/layout/DashboardSnackbarProvider";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient()

const router = createBrowserRouter([
    {
        path: "*",
        element: (
            <DashboardSnackbarProvider>
                <App/>
            </DashboardSnackbarProvider>
        )
    }
]);

const initApp = async () => {
    await initLocalization()
    HubspotChatService.init()
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <RouterProvider router={router} />
                </Provider>
            </QueryClientProvider>
        </React.StrictMode>
    )
}

initApp()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
